import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AppointmentStatusEnum } from "../types/appointment.definition";
import { ProvidedServiceEnum } from "../types/doctor.definition";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export const useAppointmentFilters = (includeAll: boolean = true) => {
  const { t } = useTranslation();

  const appointmentStatuses = useMemo(() => {
    const statuses: SelectOption[] = [];

    if (includeAll) {
      statuses.push({
        value: "",
        label: t("appointment.status.ALL"),
      });
    }

    statuses.push(
      {
        value: AppointmentStatusEnum.CONFIRMED,
        label: t(`appointment.status.${AppointmentStatusEnum.CONFIRMED}`),
      },
      {
        value: AppointmentStatusEnum.CANCELED,
        label: t(`appointment.status.${AppointmentStatusEnum.CANCELED}`),
      },
      {
        value: AppointmentStatusEnum.IN_PROGRESS,
        label: t(`appointment.status.${AppointmentStatusEnum.IN_PROGRESS}`),
      },
      {
        value: AppointmentStatusEnum.COMPLETE,
        label: t(`appointment.status.${AppointmentStatusEnum.COMPLETE}`),
      }
    );

    return statuses;
  }, [t, includeAll]);

  const providedServices = useMemo(() => {
    const services: SelectOption[] = [];

    if (includeAll) {
      services.push({
        value: "",
        label: t("profile.doctor.providedServices.types.ALL"),
      });
    }

    services.push(
      {
        value: ProvidedServiceEnum.CLINIC,
        label: t(
          `profile.doctor.providedServices.types.${ProvidedServiceEnum.CLINIC}`
        ),
      },
      {
        value: ProvidedServiceEnum.ONLINE,
        label: t(
          `profile.doctor.providedServices.types.${ProvidedServiceEnum.ONLINE}`
        ),
      },
      {
        value: ProvidedServiceEnum.HOME,
        label: t(
          `profile.doctor.providedServices.types.${ProvidedServiceEnum.HOME}`
        ),
      }
    );

    return services;
  }, [t, includeAll]);

  return {
    appointmentStatuses,
    providedServices,
    isLoading: false, // Static data, no loading needed
  };
};
